<template>
  <div class="teams-mini" :class="{ 'teams-mini--mini': mini }">
    <div class="teams-mini__my-team" style="cursor: pointer" @click="closeTeamMenu">
      <div class="d-flex align-center teams-mini__my-team-info">
        <div class="ma-0 mr-1">
          <img
            alt="Аватар пользователя"
            :src="avatarSrc || defaultAvatar"
            style="width: 32px; height: 32px; border-radius: 50%"
          />
        </div>
        <p class="teams-mini__team-name" :title="myTeam.name">{{ myTeam.name }}</p>
      </div>
      <v-icon size="14" class="left-menu__teams-chevron" color="#7B7AA8" icon="chevronUp" />
    </div>
    <div class="teams-mini__content">
      <p class="teams-mini__title">Команды</p>
      <v-btn variant="text" class="teams-mini__open-teams teams-mini__btn-hover" @click="openTeamsPage">
        <v-icon start color="text" size="16" class="ml-1" icon="openTeams" />
        Открыть команды
        <v-badge
          v-if="invitationsCount"
          :content="invitationsCount"
          :model-value="!!invitationsCount"
          color="primary"
          inline
          class="ml-4"
        ></v-badge>
      </v-btn>

      <div
        v-for="team in visibleTeams"
        :key="team.team?.slug"
        class="teams-mini__team"
        @click="changeTeam(team)"
      >
        <div v-if="team.team.slug === selectedTeam.team.slug" class="teams-mini__team-selected"></div>
        <div class="ma-0 mr-2">
          <img
            alt="Аватар пользователя"
            :src="team?.team?.owner?.avatar || defaultAvatar"
            style="width: 38px; height: 38px; border-radius: 50%"
          />
        </div>
        <div>
          <p class="teams-mini__name" :title="team.team.name">{{ team.team.name }}</p>
          <p class="teams-mini__role-name">
            {{ team.role.codename === "owner" ? "Мой личный кабинет" : team.role.name }}
          </p>
        </div>
      </div>

      <p v-if="showAllTeamsButton" class="teams-mini__show-all" @click.stop="showAllTeams">Показать все</p>

      <div class="teams-mini__border"></div>

      <v-btn variant="text" class="teams-mini__open-teams teams-mini__btn-hover" @click="goToLk">
        <v-icon color="text" size="18" class="mr-1" icon="account" />
        Открыть мой профиль
      </v-btn>
      <v-btn variant="text" class="teams-mini__open-teams teams-mini__btn-hover mb-3" @click="logout">
        <v-icon color="text" size="18" class="mr-1" icon="logout" />
        Выйти из профиля
      </v-btn>
      <!--   Подписка   -->
      <div class="teams-mini__subscription">
        <div class="d-flex align-center">
          <img alt="Логотип подписки" :src="MiniLogoPlan" class="mr-2" />
          <p class="teams-mini__subscription-status">{{ statusText }}</p>
        </div>
        <p class="teams-mini__subscription-info">
          Тарифный план: {{ subscription && subscription.plan ? subscription.plan.name : "" }}
        </p>
        <p class="teams-mini__subscription-info">
          След. платёж:
          {{
            subscription && subscription.next_payment_date ? formatDate(subscription.next_payment_date) : ""
          }}
        </p>
      </div>
      <p v-if="isTeamsExpanded" class="teams-mini__hide-all" @click.stop="hideAllTeams">Скрыть все</p>
    </div>
  </div>
</template>

<script>
import defaultAvatar from "@/assets/img/avatar.png";
import MiniLogoPlan from "@/assets/img/mini-logo-plan.svg";
import { getIncomingInvitationsApi } from "@/components/Teams/service/api";
import { eventBus } from "@/eventBus";
import { switchCurrentTeam } from "@/services/teamContext/switchCurrentTeam";
import { usePermissionsStore, useTeamStore } from "@/store/modules";

import { logoutUser } from "../service/api";

export default {
  name: "teams-mini",
  props: {
    avatarSrc: {
      type: String,
      default: "",
    },
    mini: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    MiniLogoPlan,
    defaultAvatar,
    invitations: [],
    isTeamsExpanded: false,
    teamsLimit: 8,
  }),
  computed: {
    myTeam() {
      return useTeamStore().myTeam?.team;
    },
    allTeams() {
      const teams = useTeamStore().allTeams;
      const list = Array.isArray(teams) ? teams : [];
      return list;
    },
    selectedTeam() {
      return useTeamStore().selectedTeam;
    },
    subscription() {
      return usePermissionsStore().subscription;
    },
    statusText() {
      if (!this?.subscription?.status) {
        return "";
      }
      const status = this.subscription.status;
      switch (status) {
        case "new":
          return "Ожидание оплаты";
        case "is_active":
          return "Подписка активна";
        case "past_due":
          return "Оплата просрочена";
        case "canceled":
          return "Подписка отменена";
        default:
          return "Подписка бесплатная";
      }
    },
    visibleTeams() {
      return this.isTeamsExpanded ? this.allTeams : this.allTeams.slice(0, this.teamsLimit);
    },
    showAllTeamsButton() {
      return !this.isTeamsExpanded && this.allTeams.length > this.teamsLimit;
    },
    invitationsCount() {
      return Array.isArray(this.invitations) ? this.invitations.length : 0;
    },
  },
  async mounted() {
    await this.getInvitations();
  },
  methods: {
    async changeTeam(data) {
      await switchCurrentTeam({
        team: data,
        redirect: true,
        router: this.$router,
        reloadCollections: () => {
          // временно можно оставить bus, но уже НЕ для changeTeam
          eventBus.$emit("update-all-collections", true);
        },
        reloadTags: () => {
          // временно можно оставить bus, но уже НЕ для changeTeam
          eventBus.$emit("update-all-tags", true);
        },
        mergePermissions: this.mergePermissionsMix,
      });

      this.closeTeamMenu();
      await this.getSubscription(data.team.slug);
    },
    async getSubscription(team) {
      const urlSubscription = this.$config.BASE_URL + "/api/v1/billing/subscription?team=" + team;
      try {
        const resSubscription = await this.$axios.get(urlSubscription);
        usePermissionsStore().SET_VALUE({
          key: "subscription",
          value: resSubscription.data,
        });
      } catch (error) {
        console.error(error);
      }
    },
    async getInvitations() {
      try {
        const resp = await getIncomingInvitationsApi(this.$config);

        this.invitations = Array.isArray(resp.data.results) ? resp.data.results : [];
      } catch (error) {
        console.error(error);
      }
    },
    showAllTeams() {
      this.isTeamsExpanded = true;
    },
    hideAllTeams() {
      this.isTeamsExpanded = false;
    },
    closeTeamMenu() {
      this.$emit("close-team-menu");
    },
    openTeamsPage() {
      this.$router.push("/teams");
      this.$emit("close-team-menu");
    },
    async goToLk() {
      this.$emit("close-team-menu");
      if (this.$route.name !== "profile") {
        // я хз почему, но бывает, что с первого раза не редиректит
        this.$router.push("/profile");
      }
    },
    async logout() {
      await logoutUser(this.$config);

      this.$emit("close-team-menu");
    },
    formatDate(dateString) {
      if (!dateString) return "";
      let date = new Date(dateString);
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
    },
  },
};
</script>

<style lang="scss">
.teams-mini {
  min-height: 443px;
  width: 292px;
  border-radius: 10px;
  border: 1px solid rgb(var(--v-theme-border));
  background: rgb(var(--v-theme-bg-light));
  position: fixed;
  top: 4px;
  left: 4px;
  z-index: 9;
  max-height: calc(100vh - 56px);
  overflow-y: auto;

  &--mini {
    top: 36px;
    max-height: calc(100vh - 90px);
  }

  &__my-team {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 12px 4px 4px;
    border-radius: 8px;
    background: rgb(var(--v-theme-secondary));
  }

  &__my-team-info {
    flex: 1;
    min-width: 0;
  }

  &__team-name {
    flex: 1;
    min-width: 0;
    color: rgb(var(--v-theme-primary));
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__content {
    height: auto;
    overflow: visible;
    padding: 12px 16px;
  }

  &__title {
    color: #30255e;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 14px !important;
  }

  &__open-teams {
    width: 100% !important;
    height: 38px !important;
    background: rgb(var(--v-theme-secondary));
    margin-bottom: 6px;
    justify-content: flex-start;
    padding: 6px 16px;
    .v-btn__content {
      color: rgb(var(--v-theme-text)) !important;
      font-size: 16px !important;
      font-style: normal;
      font-weight: 400;
      line-height: 22px !important;
      text-transform: none;
      letter-spacing: normal;
    }
  }

  &__btn-hover:hover {
    background-color: #c6c4ff;
    .v-btn__content {
      color: rgb(var(--v-theme-primary)) !important;
    }
    .v-icon {
      color: rgb(var(--v-theme-primary)) !important;
    }
  }

  &__team {
    width: 100%;
    height: 54px;
    border-radius: 10px;
    border: 2px solid transparent;
    background: rgb(var(--v-theme-secondary));
    margin-bottom: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 8px 16px;
    &-selected {
      width: 4px;
      height: 24px;
      border-radius: 2px;
      background: rgb(var(--v-theme-primary));
      position: absolute;
      left: 24px;
    }
  }
  &__team:hover {
    border: 2px solid rgb(var(--v-theme-border));
  }

  &__name {
    color: rgb(var(--v-theme-primary));
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    width: 170px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__role-name {
    color: rgb(var(--v-theme-text-secondary));
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }

  &__show-all {
    color: rgb(var(--v-theme-primary));
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-top: 12px !important;
    cursor: pointer;
  }

  &__hide-all {
    width: 100%;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);
    color: rgb(var(--v-theme-primary));
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    cursor: pointer;
    position: sticky;
    bottom: 0;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  &__border {
    border-bottom: 1px solid rgb(var(--v-theme-border));
    margin-bottom: 16px;
    margin-top: 16px;
  }

  &__subscription {
    border-radius: 10px;
    background: rgb(var(--v-theme-secondary));
    padding: 16px;
    &-status {
      color: rgb(var(--v-theme-text));
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
    }
    &-info {
      color: #8f84ba;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin-top: 8px !important;
    }
  }
}
</style>
